import { Reveal } from "@/components/landing/Reveal";
import { Brain, Activity, RefreshCw, ShieldCheck, Search, Trophy, LifeBuoy } from "lucide-react";

const items = [
  { icon: Brain, text: "Learns your habits" },
  { icon: Activity, text: "Tracks your progress" },
  { icon: RefreshCw, text: "Adjusts your plan" },
  { icon: ShieldCheck, text: "Keeps you accountable" },
  { icon: Search, text: "Finds opportunities" },
  { icon: Trophy, text: "Celebrates your wins" },
  { icon: LifeBuoy, text: "Helps you overcome obstacles" },
];

export const Working = () => {
  return (
    <section data-testid="working" className="relative overflow-hidden py-28">
      <div className="pointer-events-none absolute left-1/3 top-1/2 -z-10 h-[420px] w-[420px] -translate-y-1/2 glow-orange blur-3xl opacity-60" />
      <div className="pointer-events-none absolute right-1/4 top-1/2 -z-10 h-[380px] w-[380px] -translate-y-1/2 glow-violet blur-3xl opacity-50" />
      <div className="mx-auto max-w-5xl px-6 text-center lg:px-8">
        <Reveal>
          <h2 className="font-mega text-4xl leading-[0.95] text-white sm:text-5xl lg:text-6xl">
            Your AI Coach <span className="text-gradient">Never Stops Working</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground">
            While you&rsquo;re living your life, b&rarr;come is continuously working behind the
            scenes. Because reaching your goals isn&rsquo;t about motivation &mdash; it&rsquo;s about
            consistency.
          </p>
        </Reveal>

        <div className="mt-14 flex flex-wrap justify-center gap-3">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <Reveal
                key={it.text}
                delay={i * 0.05}
                className="inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-[#0C0C0E] px-5 py-3 text-sm text-white transition-colors hover:border-white/25"
              >
                <Icon className="h-4 w-4 text-gold" />
                {it.text}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Working;
